var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn__save px-3 mx-1",attrs:{"text":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"subtitle-1 text-none"},[_vm._v(_vm._s(_vm.button.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }